import { useState } from "react";
import { supabase } from "../../supabase/client";
import { useNavigate } from "react-router-dom";
import Button from "../../minicomponents/Button";
import { useUser } from "../../context/Usercontext";
let SignIng = () => {
  let { testing, sessionActive1, isSession, loadingSession, setIsSession } =
    useUser();
  const navigate = useNavigate();

  let [userEmail, setUserEmail] = useState("");
  let [userPass, setUserPass] = useState("");
  let [wrongInfo, setWrongInfo] = useState(false);

  let handleLog = async (e) => {
    e.preventDefault();
    console.log(userEmail);
    console.log(userPass);
    try {
      const { data, error } = await supabase.auth.signInWithPassword({
        email: userEmail,
        password: userPass,
      });

      console.log(data);
      if (data.user) {
        console.log(data.user);
        navigate("/profile");
        setIsSession(data.user);
      } else if (!data.user) {
        setWrongInfo(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <form onSubmit={handleLog} className="sign-in-form own-form">
      <div className="single-form-element">
        <label htmlFor="name-user">Email</label>
        <input
          type="text"
          id="name-user"
          value={userEmail}
          onChange={(e) => setUserEmail(e.target.value)}
        />
      </div>
      <div className="single-form-element">
        <label htmlFor="name-pass">Pass</label>
        <input
          type="password"
          id="pass-user"
          value={userPass}
          onChange={(e) => setUserPass(e.target.value)}
        />
      </div>

      <Button buttonStyle={"button-style-1 button-width-100"}>Log in</Button>
      {wrongInfo ? (
        <span style={{ fontSize: "0.8em", color: "red" }}>
          Incorrect credentials
        </span>
      ) : null}
    </form>
  );
};

export default SignIng;
